<div class="bg-gray-100 pb-10">
  <div
    class="p-2 md:p-10"
    *ngIf="user"
    style="width: 90%; max-width: 56rem; margin-left: auto; margin-right: auto"
  >
    <div class="flex items-center p-2 pb-0 pt-5">
      <a
        routerLink="/clients"
        class="text-sm py-1 hover:text-secondary transition ease-linear"
        >Volver a mi perfil</a
      >
    </div>
    <!-- Sección de Cambio de Contraseña -->
    <div class="p-6 md:p-10 bg-white shadow-medium rounded-2xl">
      <div class="mb-6">
        <div
          class="flex items-center gap-3 mb-3 justify-center md:justify-start"
        >
          <span
            class="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary text-white"
          >
            <i class="fa-solid fa-lock"></i>
          </span>
          <div class="w-fit">
            <h1 class="text-black font-semibold text-2xl">
              Cambio de Contraseña
            </h1>
            <div class="h-0.5 bg-primary rounded-full mt-1"></div>
          </div>
        </div>
      </div>
      <form
        [formGroup]="changePasswordForm"
        (ngSubmit)="changePassword()"
        class="space-y-6"
      >
        <div *ngIf="loading" class="text-center">
          <!-- Spinner o mensaje de carga -->
          <p>Cargando...</p>
        </div>

        <div *ngIf="success" class="text-sm font-medium text-green-600">
          Contraseña cambiada con éxito.
        </div>

        <div *ngIf="error" class="text-sm font-medium text-red-600">
          Error al cambiar la contraseña.
        </div>

        <div
          *ngIf="
            changePasswordForm.errors?.mismatch &&
            (changePasswordForm.get('confirmPassword').touched ||
              changePasswordForm.get('newPassword').touched)
          "
          class="text-red-500 text-xs mt-2"
        >
          <p class="text-red-500">Las contraseñas no coinciden.</p>
        </div>

        <!-- Campo Nueva Contraseña -->
        <div class="form-group">
          <label
            for="newPassword"
            class="block text-gray-700 text-sm font-bold mb-2"
            >Nueva Contraseña</label
          >
          <input
            id="newPassword"
            [type]="changeType ? 'password' : 'text'"
            formControlName="newPassword"
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
          <span class="eyeicon" (click)="viewPass()"
            ><i [ngClass]="visible ? 'fa fa-eye' : 'fa fa-eye-slash'"></i
          ></span>
          <!-- Mensajes de error para la Nueva Contraseña -->
          <div
            *ngIf="
              changePasswordForm.get('newPassword').touched &&
              changePasswordForm.get('newPassword').errors
            "
            class="text-red-500 text-xs mt-2"
          >
            <div
              *ngIf="changePasswordForm.get('newPassword').errors['required']"
            >
              La contraseña es obligatoria.
            </div>
            <div
              *ngIf="changePasswordForm.get('newPassword').errors['minlength']"
            >
              La contraseña debe tener al menos 8 caracteres.
            </div>
            <div
              *ngIf="changePasswordForm.get('newPassword').errors['pattern']"
            >
              La contraseña debe contener al menos una mayúscula y un número.
            </div>
          </div>
        </div>

        <!-- Campo Confirmar Nueva Contraseña -->
        <div class="form-group">
          <label
            for="confirmPassword"
            class="block text-gray-700 text-sm font-bold mb-2"
            >Confirmar Nueva Contraseña</label
          >
          <input
            id="confirmPassword"
            [type]="changeType ? 'password' : 'text'"
            formControlName="confirmPassword"
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
          <span class="eyeicon" (click)="viewPass()"
            ><i [ngClass]="visible ? 'fa fa-eye' : 'fa fa-eye-slash'"></i
          ></span>
          <!-- Mensajes de error para Confirmar Nueva Contraseña -->

          <div
            *ngIf="
              changePasswordForm.get('confirmPassword').touched &&
              changePasswordForm.get('confirmPassword').errors
            "
            class="text-red-500 text-xs mt-2"
          >
            <div
              *ngIf="
                changePasswordForm.get('confirmPassword').errors['required']
              "
            >
              Confirmar la contraseña es obligatorio.
            </div>
          </div>
        </div>

        <!-- Botón de envío -->
        <div class="flex justify-end">
          <button
            type="submit"
            [disabled]="changePasswordForm.invalid || loading"
            class="bg-gradient-to-br from-primary to-blue-900 font-bold px-8 py-3 rounded-full text-white hover:shadow-strong shadow-medium transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cambiar Contraseña
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
